import type { Ref } from "vue";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";
import dtwinsService from "~/modules/dtwin/services/dtwin.service";

export interface DeviceTypeFilter {
  label: string;
  value: string;
  uids?: string[] | undefined;
}

export async function useDeviceTypeFilters(organizationCode?: number) {
  const deviceTypeFilters: Ref<DeviceTypeFilter[]> = ref([]);
  const deviceModels: DtwinModel[] =
    await dtwinsService.getOrganizationAllDtwinModels(organizationCode);
  deviceTypeFilters.value = deviceModels.reduce(
    (acc: DeviceTypeFilter[], model: DtwinModel) => {
      const existingModel = acc.find(
        (item: DeviceTypeFilter) => item.value === model.name,
      );
      if (existingModel) {
        existingModel.uids?.push(model.uid);
      } else {
        acc.push({
          value: model.name,
          label: model.friendlyName,
          uids: [model.uid],
        });
      }
      return acc;
    },
    [],
  );

  return {
    deviceTypeFilters,
  };
}
